module.exports = __webpack_public_path__ + "img/user-tie.396b162c.svg";